import { LayerConfig } from "types";

const maybeUpdateLayer = (id: string, enabled: boolean, opacity: number) => {
  return (layer: LayerConfig) =>
    layer.id === id ? Object.assign({}, layer, { enabled, opacity }) : layer;
};

export default maybeUpdateLayer;
